import { differenceInDays, parse } from 'date-fns';

/**
 * Formats a separate date string (YYYY-MM-DD) and time string (HH:mm:ss) into a readable format:
 * e.g., "29 Aug 2026, 12:57 PM"
 */
export const dateTimeFormatter = (dateStr, timeStr) => {
  if (!dateStr) return '';
  if (!timeStr) return dateFormatter(dateStr);
  try {
    const cleanTime = timeStr.split('.')[0]; // remove milliseconds if present
    const date = new Date(`${dateStr}T${cleanTime}`);
    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
    return `${formattedDate}, ${formattedTime}`;
  } catch (e) {
    return `${dateStr} ${timeStr}`;
  }
};

/**
 * Formats a date string (YYYY-MM-DD or ISO) into a readable date:
 * e.g., "29 Aug 2026"
 */
export const dateFormatter = (dateStr) => {
  if (!dateStr) return '';
  try {
    const cleanDateStr = dateStr.split('T')[0];
    const [year, month, day] = cleanDateStr.split('-');
    if (!year || !month || !day) return dateStr;
    const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  } catch (e) {
    return dateStr;
  }
};

/**
 * Formats a raw time string (HH:mm:ss or HH:mm:ss.SSS) into 12-hour format:
 * e.g., "12:57 PM"
 */
export const timeFormatter = (timeStr) => {
  if (!timeStr) return '';
  try {
    const cleanTime = timeStr.split('.')[0];
    const [hStr, mStr] = cleanTime.split(':');
    if (!hStr || !mStr) return timeStr;
    const hours = parseInt(hStr, 10);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const h12 = hours % 12 || 12;
    return `${h12}:${mStr} ${ampm}`;
  } catch (e) {
    return timeStr;
  }
};

/**
 * Formats a single ISO Date-Time string into a readable format:
 * e.g., "29 Aug 2026, 12:57 PM"
 */
export const dateTimeFormatter2 = (dateTimeStr) => {
  if (!dateTimeStr) return '';
  try {
    const date = new Date(dateTimeStr);
    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
    return `${formattedDate}, ${formattedTime}`;
  } catch (e) {
    return dateTimeStr;
  }
};

/**
 * Legacy 12-hour time formatter by HH:mm string.
 */
export const dateTimeFormatter3 = (timeStr) => {
  return timeFormatter(timeStr);
};

/**
 * Calculates duration between admission date/time and discharge date/time (or current time):
 * e.g., "0d 3h 17m"
 */
export const calculateDuration = (admissionDate, admissionTime, dischargeDate, dischargeTime) => {
  if (!admissionDate || !admissionTime) return '-';

  const cleanStartTime = admissionTime.split('.')[0];
  const start = new Date(`${admissionDate}T${cleanStartTime}`);
  
  let end = new Date();
  if (dischargeDate && dischargeTime) {
    const cleanEndTime = dischargeTime.split('.')[0];
    end = new Date(`${dischargeDate}T${cleanEndTime}`);
  }

  const diffInMs = end - start;
  if (isNaN(diffInMs) || diffInMs < 0) return '-';

  const totalMinutes = Math.floor(diffInMs / (1000 * 60));
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  return `${days}d ${hours}h ${minutes}m`;
};
